import { render, staticRenderFns } from "./open-external.vue?vue&type=template&id=1047deee&"
import script from "./open-external.vue?vue&type=script&lang=js&"
export * from "./open-external.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1047deee')) {
      api.createRecord('1047deee', component.options)
    } else {
      api.reload('1047deee', component.options)
    }
    module.hot.accept("./open-external.vue?vue&type=template&id=1047deee&", function () {
      api.rerender('1047deee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/open-external.vue"
export default component.exports